var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMono(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7924 0.0654297H21.9072V26.4494H25.7924V0.0654297Z",
    fill: "#13100D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8985 26.4493C10.3478 26.4498 7.85421 25.6765 5.73314 24.2271C3.61208 22.7777 1.95878 20.7174 0.982344 18.3067C0.00590482 15.896 -0.249819 13.2432 0.247512 10.6838C0.744843 8.12441 1.97289 5.77339 3.77635 3.92804C5.57981 2.0827 7.87767 0.825933 10.3793 0.316675C12.881 -0.192583 15.4741 0.0685438 17.8307 1.06703C20.1873 2.06552 22.2015 3.75652 23.6187 5.92618C25.0358 8.09584 25.7922 10.6467 25.7922 13.2562C25.7885 16.7536 24.4289 20.1067 22.0117 22.58C19.5946 25.0533 16.3172 26.4449 12.8985 26.4493ZM12.8985 4.51815C11.2096 4.51815 9.55874 5.03048 8.15453 5.99036C6.75031 6.95024 5.65586 8.31455 5.00957 9.91078C4.36328 11.507 4.19418 13.2634 4.52366 14.958C4.85313 16.6525 5.66639 18.209 6.86057 19.4307C8.05476 20.6524 9.57624 21.4844 11.2326 21.8215C12.889 22.1586 14.6059 21.9856 16.1662 21.3244C17.7265 20.6632 19.06 19.5435 19.9983 18.107C20.9366 16.6704 21.4374 14.9815 21.4374 13.2537C21.4342 10.9379 20.5336 8.71784 18.9329 7.08029C17.3323 5.44274 15.1622 4.52136 12.8985 4.51815Z",
    fill: "#13100D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMono);
export default __webpack_public_path__ + "static/media/logo-mono.c2a34723e09488b30aac8eb05c9b1ad6.svg";
export { ForwardRef as ReactComponent };